export const BUTTON_SIZE = 40;
export const ARROW_SIZE = 16;
